<template>
  <div>
    <v-row align="center" class="px-3">
      <v-col
        v-for="field in filters"
        :key="field.label"
        :class="field.grid || 'xs3'"
      >
        <component
          :is="field.component"
          v-if="field.component === 'v-checkbox'"
          v-model="appliedDateFilters[field.bind]"
          :value="field.value"
          v-bind="field.props"
          @change="$emit('input', appliedDateFilters)"
        ></component>
        <v-text-field
          v-if="field.type === 'search'"
          :value="appliedDateFilters[field.bind]"
          v-bind="field.props"
          @change="
            (appliedDateFilters[field.bind] = $event),
              $emit('input', appliedDateFilters)
          "
        ></v-text-field>
        <component
          :is="field.component"
          v-else
          v-model="appliedDateFilters[field.bind]"
          :value="field.value"
          :item-text="field.itemText"
          :item-value="field.itemValue"
          v-bind="field.props"
          @input="$emit('input', appliedDateFilters)"
        ></component>
      </v-col>
      <slot></slot>
    </v-row>
  </div>
</template>
<script>
// import VueAutoComplete from "@/components/Common/FormUtils/VueAutoComplete";
// import VueUsersAutoComplete from "@/components/Common/FormUtils/VueUsersAutoComplete";
import VueTimePicker from "@/components/common/form_utils/VueTimePicker";
import VueDatePicker from "@/components/common/layout_utils/DateFilterMenu";
import VueDateTimePickerRange from "@/components/common/form_utils/VueDateTimePickerRange";
export default {
  components: {
    // VueAutoComplete,
    // VueUsersAutoComplete,
    VueTimePicker,
    VueDatePicker,
    VueDateTimePickerRange
  },
  props: {
    filters: {
      type: [Array, Object],
      required: true
    },
    alignCenter: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      appliedDateFilters: {}
    };
  },
  beforeMount() {
    this.assignDefaultValues();
  },
  methods: {
    assignDefaultValues() {
      const iterable = Array.isArray(this.filters)
        ? this.filters
        : Object.values(this.filters);
      iterable.forEach(field => {
        if (field.default) {
          this.appliedDateFilters[field.bind] = field.default;
        }
      });
    }
  }
};
</script>
